import React from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, Switch, FormControlLabel } from "@material-ui/core";
import SectionCard from "./SectionCard";

const SubAgentDebt: React.FC = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<any>();

  return (
    <SectionCard title="Debt & Status">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField fullWidth name="actualDebt" label="Actual Debt" value={values.actualDebt || ""} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField fullWidth name="debtBeforeEnding" label="Debt Before Ending" value={values.debtBeforeEnding || ""} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControlLabel
            control={
              <Switch
                checked={values.status ?? true}
                onChange={(_, v) => setFieldValue("status", v)}
                color="primary"
              />
            }
            label="Status active"
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default SubAgentDebt;
